import React from 'react'
import {Link} from "react-router-dom"

const NFTInfoButton = () => {
  return (
    <Link to="/" style={{color:"black"}}>
        <i className="ri-information-line"></i>
      </Link>
  )
}

export default NFTInfoButton